import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Button, CardBody } from "react-bootstrap";
import AttachmentFile from "../../../../../src/assets/images/attachment-file.svg";
import { generateAppropriateDate } from "../../basic-component/DateUtils";
import {
  apiHostUrl,
  fileDownloadUrl,
  sendMailUrl,
  skeleton_animation_style_primary,
} from "../../../../constants/constants";
import { useSelector } from "react-redux";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@mui/material";
import { display } from "@mui/system";
import {
  removeHTMLElementsAndTruncateText,
  truncateText,
} from "../../basic-component/CommonUtils";
import RichTextEditor from "../../basic-component/TextEditor/RichTextEditor";
import useAxiosFetchData from "../../../hooks/useAxiosFetchData";
import PluginSnackbar from "../../basic-component/Snackbar";
import { htmlToPlainText } from "../../basic-component/Modal/AddFeedbackModalCustomerType";
import { setReloadFeedbackDetails } from "../../../system/redux/reducers/reloadFeedbackDetails";
import { useDispatch } from "react-redux";
import { mailListForCustomerResponse } from './CustomerResponsePopup';
import {getResponseDetailsUrl} from "../../../../constants/constants";
import axios from "axios";
const MailReply = (data) => {
  debugger;
  console.log(data);
  console.log(data.customerResponseData);
  console.log(data.feedbackid);
  const { t } = useTranslation();
  const [description, setDescription] = useState();
  console.log(data?.data?.serviceMailList);
  console.log(data?.data?.addFileList?.description);
  const [fileDownlod, setfileDownload] = useState([]);
  const { homeLink, userEmail, userName, userCurrRole } = useSelector(
    (state) => state.role
  );
  const isInternalUser = [102, 104, 105, 106].includes(userCurrRole.id);
  const url = apiHostUrl + homeLink + fileDownloadUrl;
  const [mailList, setMailList] = useState([]);
  const [mailId, setmailId] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const extractMessage = (html) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    return tempElement.textContent || tempElement.innerText || "";
  };
  const limitExtractMessage = (html, wordLimit) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    const textContent = tempElement.textContent || tempElement.innerText || "";
    const words = textContent.split(" ");
    const truncatedText = words.slice(0, wordLimit).join(" ");
    return truncatedText + (words.length > wordLimit ? "..." : ""); // Add ellipsis if the text is truncated
  };
  const [replyToggle, setReplyToggle] = useState(true);

  const getStatus = (currentStatus) => {
    switch (currentStatus) {
      case "Work In Progress":
        return "wip";
      case "New":
        return "new";
      case "Active":
        return "wip";
      case "Assigned":
        return "wip";
      case "Accepted":
        return "wip";
      case "Close":
        return "closed";
      case "Resolved":
        return "resolved";
      case "Closed":
        return "closed";
      case "Overdue":
        return "overdue";
      case "Reopened":
        return "reopened";
      default:
        return "overdue";
    }
  };

  //   const { onMailOpen } = data // Destructure onMailOpen from props
  //   const handleMailOpen = (mail) => {
  //     console.log(mail); // Print data.mail when the function is called
  //     // Add any other logic you need here
  //   };

  //  console.log(data.onMailOpen());
  //   handleMailOpen(data.mail);

  // onMailOpen(handleMailOpen);
  const [openSnackbarMailSent, setOpenSnackbarMailSent] = useState(false);
  const { csrfToken } = useSelector((state) => state.csrf);

  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": csrfToken,
  };
  const [CreatoremailId, setEmailId] = useState("");
  const [creatorName, setCreatorName] = useState("");
  const [mailBody, setMailBody] = useState("");
  const isMailReplyAvailable =
    isInternalUser &&
    true &&
    data?.data?.feedbackDetails?.status
      .trim()
      .localeCompare("CLOSED", "en-US", { sensitivity: "base" }) !== 0;
  const dispatch = useDispatch();
  useEffect(() => {
    const handleStorageChange = (event) => {
      setMailBody(event.target.sessionStorage.editorContent);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  // useEffect(()=>{
  //   setMailBody(sessionStorage.getItem('editorContent'));
  // },[sessionStorage.getItem('editorContent')]);
  const { fetchData: sendMail } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${sendMailUrl}`,
    method: "POST",
    body: {
      fromRecipient: {
        address: userEmail,
        personal: userName,
      },
      toRecipients: [
        {
          address: CreatoremailId,
          personal: creatorName,
        },
      ],
      body: mailBody,
      subject: "Reply Suggestion Email",
      referenceId: data.data?.feedbackDetails?.id,
    },
    headers: headers,
    onLoad: false,
  });
  const multiPartHeaders = {
      "Content-Type": "multipart/form-data",
      "X-CSRF-TOKEN": csrfToken,
    };
  const [snackSwitch, setSnackSwitch] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");

  useEffect(() => {
    // console.log(data?.data?.commentDetails);
    setEmailId(data.data?.feedbackDetails?.user?.email || "");
    setCreatorName(
      data.data?.feedbackDetails?.user?.firstName +
        " " +
        data.data?.feedbackDetails?.user?.lastName
    );
    console.log(data?.data?.serviceMailList);
    setMailList([]);
   /*  setMailList(prev => [...prev, ...(data?.data?.serviceMailList || [])]);
     setMailList(prev => [...prev, ...(data?.data?.customerMailDetails || [])]);
     setMailList(prev => [...prev, ...(data?.customerResponseData || [])]);*/
     debugger;
    const mergedMailList = [
      ...(data?.data?.serviceMailList || []),
      ...(data?.data?.customerMailDetails || []),
      ...(data?.customerResponseData || [])
    ];
    mergedMailList.sort((a, b) => b.lastAttemptDate - a.lastAttemptDate);
   setMailList(mergedMailList);
//    setMailList(data?.data?.serviceMailList || []);
//   setMailList(data?.customerResponseData || []);
    debugger;
    console.log(data?.data?.addFileList);
    setfileDownload(data?.data?.addFileList);
    console.log(data.mail);
    setmailId(data.mail);
    setDescription(data?.data?.feedbackDetails?.description || "");

    if (data?.data && data?.data?.feedbackDetails?.status) {
      setCurrentStatus(data.data.feedbackDetails.status);
    } else if (data?.data && data?.data?.status) {
      setCurrentStatus(data.data.status);
    }
  }, [data]);

  const message = extractMessage(
    data?.data?.feedbackDetails?.description || ""
  );
  const trimmedMessage = message.trim();
  console.log("Trimmed message:", trimmedMessage);

  let truncatedMessage = removeHTMLElementsAndTruncateText(trimmedMessage, 20);

  // const [activeKey, setActiveKey] = useState(mailId ? mailId.toString() : null);
  // useEffect(()=>{
  //   console.log(data.mail);
  //   setActiveKey(mailId ? mailId.toString() : null);
  // },[data.mail]);

  // const handleToggle = (eventKey) => {
  //   setActiveKey(activeKey === eventKey ? null : eventKey);
  // };

  useEffect(() => {}, [data.mail]);

  useEffect(() => {
    debugger;
    setCardShow((prev) => {
      const updatedCardShow = {};
      mailList?.forEach((mailItem, index) => {
        updatedCardShow[index] =
          mailItem.id === mailId ? !prev[index] : prev[index];
      });
      return updatedCardShow;
    });
  }, [mailList, mailId]);

  const [cardShow, setCardShow] = useState({});

  const toggleShow = (index) => {
    setCardShow((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  debugger;
  console.log(mailList);
  return (
    <>
      <Col lg="8" className="conversation-log">
        <Card className="rounded-0 border-0 bg-transparent h-100">
          <Card.Header className="fs-5 fw-medium bg-transparent border-color-blue">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="d-flex align-items-center">
                {description ? (
                  <i className="ti ti-notes"></i>
                ) : (
                  <>
                    <Skeleton
                      animation={skeleton_animation_style_primary}
                      variant="circular"
                      width={20}
                      height={20}
                      className="me-1"
                    />
                    <Skeleton
                      animation={skeleton_animation_style_primary}
                      variant="rounded"
                      width={537}
                    />
                  </>
                )}
                {description ? (
                  <>{truncatedMessage}</>
                ) : (
                  <>
                    {/* <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={20} /> */}
                  </>
                )}
              </div>
              {currentStatus ? (
                <>
                  {" "}
                  <span
                    className={`${getStatus(
                      currentStatus
                    )}-bg-color badge rounded-pill bg-primary lh-normal`}
                  >
                    {" "}
                    <i class="ti ti-folder-open"></i> {currentStatus}
                  </span>
                </>
              ) : (
                <>
                  {" "}
                  <Skeleton
                    animation={skeleton_animation_style_primary}
                    variant="rounded"
                    height={20}
                    width={40}
                    className="ms-1"
                  />
                </>
              )}
            </div>
          </Card.Header>

          <Card.Body>
            {description ? (
              <>
                <Card className="common-reply creator-card">
                  <Card.Body className="p-0">
                    <Row className="g-3">
                      {description && (
                        <>
                          {" "}
                          <Col lg="auto">
                            <div className="mail-profile"></div>
                          </Col>
                          <Col>
                            <p className="mail-date">
                              {generateAppropriateDate(
                                data?.data?.feedbackDetails?.createDate
                              )}
                            </p>
                            {/* <p className='mail-date'>December 10, 2023 at 11:31a.m</p> */}
                            <h5 className="mail-sender-name fw-medium mt-2">
                              {t("feedbackDetails.feedbackDescription.text")}
                            </h5>
                            {/* <h6 className='fw-normal'>
                    <i className="ti ti-mail-forward me-2"></i>
                    <span className='fw-medium'>To: </span>
                    <span className='mail-id'>support@mail.in</span>
                  </h6> */}
                            {/* <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6> */}
                            <p
                              className="mail-body mb-0"
                              dangerouslySetInnerHTML={{
                                __html: data?.data?.feedbackDetails?.description
                                  ? data.data.feedbackDetails.description
                                  : "N/A",
                              }}
                            >
                              {/* Hello, */}

                              {/* {extractMessage(data?.data?.feedbackDetails?.description ? data.data.feedbackDetails.description : "N/A")} */}
                              {/* <br></br>
                    Thank you,
                    <br></br>
                    Abhishek */}
                            </p>
                            <div className="attachments">
                              {fileDownlod?.map((file, index) => (
                                <a
                                  key={index}
                                  className="file text-decoration-none my-2"
                                  href={url + "/" + file.description} // Assuming each file object in data contains a filePath property
                                  download={file.fileName} // Assuming each file object in data contains a fileName property
                                  target="_blank" rel="noreferrer"
                                  title={file.description} 
                                >
                                  <img src={AttachmentFile} alt="Attachment" />
                                  <div className="file-details mx-2 text-dark">
                                    <h6 className="file-name mb-1">
                                      {truncateText(
                                        file?.originalFileName
                                          ? file.originalFileName
                                          : file?.description
                                          ? file.description
                                          : "",
                                        20
                                      )}
                                    </h6>
                                    {/* <p className='file-size mb-0'>{file.fileSize} {t('general.label.kb')}</p> */}
                                  </div>
                                  <i className="ti ti-download fs-4 text-secondary"></i>
                                </a>
                              ))}

                              {/* <a className='file text-decoration-none mt-2' href='#'>
                      <img src={AttachmentFile}></img>
                      <div className='file-details mx-2 text-dark'>
                        <h6 className='file-name mb-1'>File_name.pdf</h6>
                        <p className='file-size mb-0'>34 KB</p>
                      </div>
                      <i class="ti ti-download fs-4 text-secondary"></i>
                    </a> */}
                          </div>
                          </Col>
                        </>
                      )}
                    </Row>

                    {isMailReplyAvailable &&
                      (replyToggle ? (
                        <>
                          <Card
                            // key={index}
                            className="common-reply others-reply-card"
                            onClick={() => setReplyToggle((prev) => !prev)}
                          >
                            <Card.Body className="p-2">
                              <Row className="g-3">
                                <Col lg="auto">
                                  <div className="mail-profile auto-reply"></div>
                                </Col>
                                <Col>
                                {/* debugger; */}
                                  <h5 className="mail-sender-name fw-medium">
                                    {t("general.label.feedbackUpdates")}
                                  </h5>
                                  <p className="mail-body mb-0">
                                    {t("general.description.feedback.update")}
                                  </p>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </>
                      ) : (
                        <>
                          <Card
                            className="common-reply others-reply-card"
                            // onClick={() => setReplyToggle((prev) => !prev)}
                          >
                            <Card.Body className="p-2">
                              <Row className="g-3">
                                {/* <Col lg="auto">
                                  <div className="mail-profile"></div>
                                </Col> */}
                                <Col>
                                  {/* <h6 className="fw-normal">
                                    <i className="ti ti-mail-forward me-2"></i>
                                    <span className="fw-medium">From: </span>
                                    <span className="mail-id">{userEmail}</span>
                                  </h6> */}
                                  <h6 className="fw-normal">
                                    <i className="ti ti-mail-forward me-2"></i>
                                    <span className="fw-medium">To: </span>
                                    <span className="mail-id">
                                      {CreatoremailId}
                                    </span>
                                  </h6>
                                  <h6 className="mail-subject mb-3">
                                    <RichTextEditor></RichTextEditor>
                                  </h6>
                                  <p>
                                    <Button
                                      variant="primary"
                                      onClick={async () => {
                                        console.log("Hello");
                                        setLoading(true);

                                        try {
                                          const data = await sendMail();
                                          console.log(data);

                                          setMailBody("");

                                          if (data.success === true) {
                                            setOpenSnackbarMailSent(true);
                                            setReplyToggle((prev) => !prev);
                                            dispatch(
                                              setReloadFeedbackDetails({
                                                value: true,
                                              })
                                            );
                                          }
                                        } catch (err) {
                                          console.error(err);
                                        } finally {
                                          setLoading(false);
                                        }
                                      }}
                                      disabled={loading}
                                    >
                                      <span className="d-inline-flex align-items-center">
                                        <span>{t("general.label.send.reply")}</span>
                                        {loading && (
                                          <span className="spinner-border spinner-border-sm ms-2"></span>
                                        )}
                                      </span>
                                    </Button>
                                  </p>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </>
                      ))}
                  </Card.Body>
                </Card>
              </>
            ) : (
              <>
                <Row className="g-2 mb-1">
                  <Col lg="auto">
                    <Skeleton
                      animation={skeleton_animation_style_primary}
                      variant="circular"
                      width={45}
                      height={45}
                      className=""
                    />
                  </Col>
                  <Col>
                    <Skeleton
                      animation={skeleton_animation_style_primary}
                      variant="rounded"
                      height={45}
                    />
                  </Col>
                </Row>
              </>
            )}
            {description ? (
              <>
                {mailList?.map((mailItem, index) => (
                  <>
                    {cardShow[index] ? (
                      <Card
                        key={index}
                        className="common-reply others-reply-card"
                        onClick={() => toggleShow(index)}
                      >
                        <Card.Body className="p-2">
                          <Row className="g-3">
                            <Col lg="auto">
                              <div className="mail-profile"></div>
                            </Col>
                            <Col>
                              <p className="mail-date">
                                {generateAppropriateDate(
                                  mailItem.lastAttemptDate
                                )}
                              </p>
                              <h5 className="mail-sender-name fw-medium mt-2">
                                {mailItem.comment ? mailItem.responderEmail : mailItem.mailFromStr}{" "} 
                                {/* {mailItem.mailFromStr}{" "} */}
                                {t("general.label.replied")}
                              </h5>
                              <h6 className="fw-normal">
                                <i className="ti ti-mail-forward me-2"></i>
                                <span className="fw-medium">
                                  {t("general.label.to")}:{" "}
                                </span>
                                <span className="mail-id">
                                  {mailItem.comment ? "feedback@mjunction.in" :mailItem.mailToStr} 
                                   {/* {mailItem.mailToStr}   */}
                                </span>
                              </h6>
                              <h6 className="mail-subject mb-3">
                                {t("general.label.subject")}: {mailItem.subject}
                              </h6>
                              <p className="mail-body mb-0">
                                {extractMessage(mailItem.body)}
                              </p>
                              {mailItem?.attachment && (mailItem.referenceTypeId === 108 || mailItem.referenceTypeId === 106) ? (
                                <div className="attachments">
                                      <a
                                        key={mailItem.attachment.id}
                                        className="file text-decoration-none mt-2"
                                        href={url + "/" + mailItem.attachment.description} // Assuming each file object in data contains a filePath property
                                        download={mailItem.attachment.fileName} // Assuming each file object in data contains a fileName property
                                        target="_blank"
                                      >
                                        <img
                                          src={AttachmentFile}
                                          alt="Attachment"
                                        />
                                        <div className="file-details mx-2 text-dark">
                                          <h6 className="file-name mb-1">
                                            {truncateText(
                                              mailItem.attachment?.originalFileName
                                                ? mailItem.attachment.originalFileName
                                                : mailItem.attachment?.description
                                                ? mailItem.attachment.description
                                                : "",
                                              20
                                            )}
                                          </h6>
                                          {/* <p className='file-size mb-0'>{file.fileSize} {t('general.label.kb')}</p> */}
                                        </div>
                                        <i className="ti ti-download fs-4 text-secondary"></i>
                                      </a>
                                    
                                </div>
                              ) : (
                                <></>
                              )}
                              {mailItem?.attachments && mailItem.attachments.length>0 && (mailItem.referenceTypeId === 108 || mailItem.referenceTypeId === 106) ? (
                                <div className="attachments">
                                  {mailItem.attachments.map((attachment) => (
                                      <a
                                        key={attachment.id}
                                        className="file text-decoration-none mt-2"
                                        href={url + "/" + attachment.description} // Assuming each file object in data contains a filePath property
                                        download={attachment.fileName} // Assuming each file object in data contains a fileName property
                                        target="_blank"
                                        title={attachment.description} 
                                      >
                                        <img
                                          src={AttachmentFile}
                                          alt="Attachment"
                                        />
                                        <div className="file-details mx-2 text-dark">
                                          <h6 className="file-name mb-1">
                                            {truncateText(
                                              attachment?.originalFileName
                                                ? attachment.originalFileName
                                                : attachment.description
                                                ? attachment.description
                                                : "",
                                              20
                                            )}
                                          </h6>
                                          {/* <p className='file-size mb-0'>{file.fileSize} {t('general.label.kb')}</p> */}
                                        </div>
                                        <i className="ti ti-download fs-4 text-secondary"></i>
                                      </a>
                                    ))}
                                </div>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    ) : (
                      <Card
                        key={index}
                        className="common-reply others-reply-card"
                        onClick={() => toggleShow(index)}
                      >
                        <Card.Body className="p-2">
                          <Row className="g-3">
                            <Col lg="auto">
                              <div className="mail-profile"></div>
                            </Col>
                            <Col>
                              <p className="mail-date">
                                {generateAppropriateDate(
                                  mailItem.lastAttemptDate
                                )}
                              </p>
                              <h5 className="mail-sender-name fw-medium mt-2">
                                 {mailItem.comment ? mailItem.responderEmail : mailItem.mailFromStr}{" "} 
                                {/* {mailItem.mailFromStr}{" "} */}
                                {t("general.label.replied")}
                              </h5>
                              <p className="mail-body mb-0">
                                {limitExtractMessage(mailItem.body, 15)}
                              </p>
                              {mailItem?.attachment && (mailItem.referenceTypeId === 108 || mailItem.referenceTypeId === 106) ? (
                                <div className="attachments">
                                      <a
                                        key={mailItem.attachment.id}
                                        className="file text-decoration-none mt-2"
                                        href={url + "/" + mailItem.attachment.description} // Assuming each file object in data contains a filePath property
                                        download={mailItem.attachment.fileName} // Assuming each file object in data contains a fileName property
                                        target="_blank"
                                      >
                                        <img
                                          src={AttachmentFile}
                                          alt="Attachment"
                                        />
                                        <div className="file-details mx-2 text-dark">
                                          <h6 className="file-name mb-1">
                                            {truncateText(
                                              mailItem.attachment?.originalFileName
                                                ? mailItem.attachment.originalFileName
                                                : mailItem.attachment?.description
                                                ? mailItem.attachment.description
                                                : "",
                                              20
                                            )}
                                          </h6>
                                          {/* <p className='file-size mb-0'>{file.fileSize} {t('general.label.kb')}</p> */}
                                        </div>
                                        <i className="ti ti-download fs-4 text-secondary"></i>
                                      </a>
                                </div>
                              ) : (
                                <></>
                              )}
                              {mailItem?.attachments && mailItem.attachments.length>0 && (mailItem.referenceTypeId === 108 || mailItem.referenceTypeId === 106) ? (
                                <div className="attachments">
                                  {mailItem.attachments.map((attachment) => (
                                      <a
                                        key={attachment.id}
                                        className="file text-decoration-none mt-2"
                                        href={url + "/" + attachment.description} // Assuming each file object in data contains a filePath property
                                        download={attachment.fileName} // Assuming each file object in data contains a fileName property
                                        target="_blank"
                                      >
                                        <img
                                          src={AttachmentFile}
                                          alt="Attachment"
                                        />
                                        <div className="file-details mx-2 text-dark">
                                          <h6 className="file-name mb-1">
                                            {truncateText(
                                              attachment?.originalFileName
                                                ? attachment.originalFileName
                                                : attachment?.description
                                                ? attachment.description
                                                : "",
                                              20
                                            )}
                                          </h6>
                                          {/* <p className='file-size mb-0'>{file.fileSize} {t('general.label.kb')}</p> */}
                                        </div>
                                        <i className="ti ti-download fs-4 text-secondary"></i>
                                      </a>
                                  ))}
                                </div>
                              ) : (
                                <></>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    )}
                  </>
                ))}
              </>
            ) : (
              <Row className="g-2 mb-1">
                <Col lg="auto">
                  <Skeleton
                    animation={skeleton_animation_style_primary}
                    variant="circular"
                    width={45}
                    height={45}
                    className=""
                  />
                </Col>
                <Col>
                  <Skeleton
                    animation={skeleton_animation_style_primary}
                    variant="rounded"
                    height={45}
                    className="mb-1"
                  />
                </Col>
              </Row>
            )}

            {/* <Card className='common-reply others-reply-card'>
            <Card.Body className='p-2'>
              <Row className='g-3'>
                <Col lg="auto">
                  <div className='mail-profile'></div>
                </Col>
                <Col>
                  <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                  <h5 className='mail-sender-name fw-medium mt-2'>
                    mjunction replied
                  </h5>
                  <p className='mail-body mb-0'>
                    Hi Abhishek Chakladar,
                    Congratulations! am has received your complaint.
                    Best Regards
                  </p>

                </Col>
              </Row>
            </Card.Body>
          </Card> */}

            {/* <Col lg="8" className='conversation-log ps-0'>
                <Card className='rounded-0 border-0 bg-transparent'>
                  <Card.Header className='fs-5 fw-medium bg-transparent border-color-blue'><i class="ti ti-notes"></i> Order Delay complaint heading</Card.Header>
                  <Card.Body>

                    <Card className='common-reply others-reply-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              mjunction replied
                            </h5>
                            <h6 className='fw-normal'>
                              <i className="ti ti-mail-forward me-2"></i>
                              <span className='fw-medium'>To: </span>
                              <span className='mail-id'>abhishek.chakladar@mail.in</span>
                            </h6>
                            <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                            <p className='mail-body mb-0'>
                              Hi Abhishek Chakladar,
                              <br></br>
                              Congratulations! am has received your complaint.
                              <br></br>
                              Best Regards
                            </p>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <Card className='common-reply others-reply-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              mjunction replied
                            </h5>
                            <p className='mail-body mb-0'>
                              Hi Abhishek Chakladar,
                              Congratulations! am has received your complaint.
                              Best Regards
                            </p>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <Card className='common-reply auto-reply-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              mjunction auto replied - New Ticket
                            </h5>
                            <h6 className='fw-normal'>
                              <i className="ti ti-mail-forward me-2"></i>
                              <span className='fw-medium'>To: </span>
                              <span className='mail-id'>abhishek.chakladar@mail.in</span>
                            </h6>
                            <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                            <p className='mail-body mb-0'>
                              Hi Abhishek Chakladar,
                              <br></br>
                              We apologize for your recent poor experience. An agent will reach out to you prompt to address your concerns.
                              <br></br>
                              Best Regards
                            </p>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    <Card className='common-reply creator-card'>
                      <Card.Body className='p-2'>
                        <Row className='g-3'>
                          <Col lg="auto">
                            <div className='mail-profile'></div>
                          </Col>
                          <Col>
                            <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                            <h5 className='mail-sender-name fw-medium mt-2'>
                              Abhishek Chakladar
                            </h5>
                            <h6 className='fw-normal'>
                              <i className="ti ti-mail-forward me-2"></i>
                              <span className='fw-medium'>To: </span>
                              <span className='mail-id'>support@mail.in</span>
                            </h6>
                            <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                            <p className='mail-body mb-0'>
                              Hello,
                              <br></br>
                              I place an order on 1st of Dec. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s.
                              <br></br>
                              Thank you,
                              <br></br>
                              Abhishek
                            </p>
                            <div className='attachments'>

                              <a className='file text-decoration-none mt-2' href='#'>
                                <img src={AttachmentFile}></img>
                                <div className='file-details mx-2 text-dark'>
                                  <h6 className='file-name mb-1'>File_name.pdf</h6>
                                  <p className='file-size mb-0'>34 KB</p>
                                </div>
                                <i class="ti ti-download fs-4 text-secondary"></i>
                              </a>

                              <a className='file text-decoration-none mt-2' href='#'>
                                <img src={AttachmentFile}></img>
                                <div className='file-details mx-2 text-dark'>
                                  <h6 className='file-name mb-1'>File_name.pdf</h6>
                                  <p className='file-size mb-0'>34 KB</p>
                                </div>
                                <i class="ti ti-download fs-4 text-secondary"></i>
                              </a>

                            </div>

                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                  </Card.Body>
                </Card>

              </Col> */}

            {/* Your existing code
          <Accordion activeKey={activeKey} onToggle={handleToggle} alwaysOpen>
      {mailList?.map((mailItem, index) => (
        <Accordion.Item eventKey={mailItem.id.toString()} key={index}>
          <Card className='common-reply others-reply-card'>
            <Accordion.Header onClick={() => handleToggle(mailItem.id.toString())} bsPrefix='common-reply others-reply-card'>
              <Card.Body className='p-2'>
                <Row className='g-3'>
                  <Col lg="auto">
                    <div className='mail-profile'></div>
                  </Col>
                  <Col>
                    <p className='mail-date'>{generateAppropriateDate(mailItem.lastAttemptDate)}</p>
                    <h5 className='mail-sender-name fw-medium mt-2'>
                      {mailItem.mailFromStr} replied
                    </h5>
                    <h6 className='fw-normal'>
                      <i className="ti ti-mail-forward me-2"></i>
                      <span className='fw-medium'>To: </span>
                      <span className='mail-id'>{mailItem.mailToStr}</span>
                    </h6>
                    <h6 className='mail-subject mb-3'>Subject: {mailItem.subject}</h6>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Header>
            <Accordion.Body>
              <Card.Body className='p-2'>
                <Row className='g-3'>
                  <Col>
                    <p className='mail-body mb-0'>
                      {extractMessage(mailItem.body)}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Body>
          </Card>
        </Accordion.Item>
      ))}
    </Accordion> */}

            {/* <Card className='common-reply auto-reply-card'>
            <Card.Body className='p-2'>
              <Row className='g-3'>
                <Col lg="auto">
                  <div className='mail-profile'></div>
                </Col>
                <Col>
                  <p className='mail-date'>December 10, 2023 at 11:31a.m</p>
                  <h5 className='mail-sender-name fw-medium mt-2'>
                    mjunction auto replied - New Ticket
                  </h5>
                  <h6 className='fw-normal'>
                    <i className="ti ti-mail-forward me-2"></i>
                    <span className='fw-medium'>To: </span>
                    <span className='mail-id'>abhishek.chakladar@mail.in</span>
                  </h6>
                  <h6 className='mail-subject mb-3'>Subject: dummy text heading</h6>
                  <p className='mail-body mb-0'>
                    Hi Abhishek Chakladar,
                    <br></br>
                    We apologize for your recent poor experience. An agent will reach out to you prompt to address your concerns.
                    <br></br>
                    Best Regards
                  </p>

                </Col>
              </Row>
            </Card.Body>
          </Card> */}
          </Card.Body>
        </Card>
      </Col>
      <PluginSnackbar
        open={openSnackbarMailSent}
        message={t("mail.sent.success.message")}
        onClose={() => {
          setOpenSnackbarMailSent(false);
        }}
      ></PluginSnackbar>
    </>
  );
};
export default MailReply;
